import { createTrackingUtils } from "..";

const utils = createTrackingUtils({
  name: "flights_apex_web_ryanair_ancillaries_price_label",
  stages: {
    main: 1,
    fd: 2,
    fd_ddot: 3,
    fd_mdot: 4,
    baggage: 5,
    seats: 6,
    cnp: 7,
    pb: 8
  },
  defaultStage: 1,
  goals: {}
});

export default utils;
